import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { listOrgs, createOrg } from "../api/orgs.js";
import type { Organisation, OrgType } from "../api/types.js";
import type { CreateOrgRequest } from "../api/orgs.js";

export function useOrgs() {
  return useQuery<{ orgs: Organisation[] }>({
    queryKey: ["orgs"],
    queryFn: listOrgs,
  });
}

export function useCreateOrg() {
  const qc = useQueryClient();
  return useMutation<
    { ok: boolean; org: Organisation },
    Error,
    CreateOrgRequest
  >({
    mutationFn: createOrg,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["orgs"] });
    },
  });
}

export function useFirstOrg(): Organisation | null {
  const { data } = useOrgs();
  return data?.orgs[0] ?? null;
}

export type { OrgType };
